import React, {useContext} from "react";
import {Checkbox, Tooltip} from "antd";
import {QuestionCircleOutlined} from "@ant-design/icons";
import {CheckboxController} from "./PaymentInputHelper";
import {PaymentType} from "../../../consts.js";
import "./PaymentInput/payment-input.css";
import {AppContext} from "../../../AppContext.jsx";

export const BankTransferPaymentInput = ({
    paymentType,
    setPaymentType,
    onSeparateInvoiceChange,
    separateInvoice,
    me
}) => {
    return (
        <div className="payment-input-container">
            <div className={"payment-input-options-header"}>
                <CheckboxController
                    isChecked={paymentType === PaymentType.BankTransfer}
                    setPaymentType={type => setPaymentType(type)}
                    type={PaymentType.BankTransfer}
                />
                {"הוספה לחשבונית מרכזת לתשלום"}
                <Tooltip
                    title={
                        <p className="payment-input-tooltip-text">
                            בחירה באפשרות החשבונית החודשית כאמצעי תשלום לעסקה, מאפשרת לכם להוסיף את העסקה הספציפית לתוך
                            החשבונית החודשית שלכם. החשבונית תשלח בסוף החודש ותרכז את כל ההזמנות ששייכתם אליה באותו חודש
                            קלנדרי, לתשלום בהעברה בנקאית לפי תנאי השוטף
                        </p>
                    }>
                    <QuestionCircleOutlined className="payment-input-tooltip-icon" />
                </Tooltip>
            </div>
            <div className={"payment-input-bank-option-subtitle"}>
                {"בהתאם לתנאי החברה בהעברה בנקאית לפי תנאי השוטף "}
            </div>
            {paymentType === PaymentType.BankTransfer && me?.features?.transaction_separate_invoice ? (
                <div className="payment-input-bank-option-subtitle">
                    <div className="payment-input-bank-transfer-different-invoice">
                        <Checkbox onChange={e => onSeparateInvoiceChange(e.target.checked)} checked={separateInvoice}>
                            אשמח בהפרדת העסקה לחשבונית נפרדת
                        </Checkbox>
                    </div>
                </div>
            ) : null}
        </div>
    );
};
